export const FORGET_PASSWORD = "FORGET_PASSWORD"
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS"
export const FORGET_PASSWORD_ERROR = "FORGET_PASSWORD_ERROR"


export const VERIFY_FORGET_PASSWORD = "VERIFY_FORGET_PASSWORD"
export const VERIFY_FORGET_PASSWORD_SUCCESS = "VERIFY_FORGET_PASSWORD_SUCCESS"
export const VERIFY_FORGET_PASSWORD_FAIL = "VERIFY_FORGET_PASSWORD_FAIL"


export const  RESEND_FORGET_PASSWORD_CODE = "RESEND_FORGET_PASSWORD_CODE"
export const  RESEND_FORGET_PASSWORD_CODE_SUCCESS = "RESEND_FORGET_PASSWORD_CODE_SUCCESS"
export const  RESEND_FORGET_PASSWORD_CODE_FAIL = "RESEND_FORGET_PASSWORD_CODE_FAIL"